import styled from 'styled-components';
import { colors } from '../../styles/Colors';
import { TextBold } from '../../styles/GlobalStyledComponents';

export const UnavailableImageWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  margin-top: 3.5rem;
  margin-bottom: 3.5rem;
`;

export const UnavailableImage = styled.img`
  width: 100px;
`;

export const UnavailableLink = styled.a`
  color: ${colors.red6};
  text-decoration: underline;
  font-size: 14px;
  font-weight: 600;
  margin: 14px 0;
`;

export const UnavailableLinkClave = styled.a`
  color: ${colors.red6};
  text-decoration: underline;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  text-align: justify;
  margin: 14px 0;
`;

export const UnavailableContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const UnavailableList = styled.ul`
  margin: 20px 0 6px;
  padding-left: 18px;
  color: ${colors.gray6};
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
`;

export const UnavailableListItem = styled.li`
  padding-left: 4px;
  color: ${colors.gray6};
`;

export const TextTel = styled(TextBold)`
  white-space: nowrap;
`;
